import { Linkedin, Mail } from "lucide-react";

const ContactSection = () => {
  return (
    <>
      <section id="contact" className="section-padding bg-secondary">
        <div className="content-max">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-headline text-3xl sm:text-4xl md:text-5xl text-foreground tracking-tight mb-4">
              Let's Build Something
            </h2>
            <p className="font-body text-base md:text-lg text-muted-foreground mb-10 md:mb-14">
              Ready to scale? Reach out directly — I'd love to hear what you're working on.
            </p>

            <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4">
              <a
                href="mailto:eric@taylorgrowthconsulting.com"
                className="group flex items-center justify-center gap-3 bg-card border border-border rounded-xl px-8 py-5 transition-all duration-300 hover:border-primary/40 hover:shadow-[0_0_24px_-6px_hsl(var(--primary)/0.15)] hover:-translate-y-0.5 no-underline"
                aria-label="Email Eric"
              >
                <Mail size={22} className="text-primary shrink-0" />
                <span className="font-body text-sm md:text-base text-foreground group-hover:text-foreground transition-colors">
                  eric@taylorgrowthconsulting.com
                </span>
              </a>
              <a
                href="https://www.linkedin.com/in/ericgriffithtaylor"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center justify-center gap-3 bg-card border border-border rounded-xl px-8 py-5 transition-all duration-300 hover:border-primary/40 hover:shadow-[0_0_24px_-6px_hsl(var(--primary)/0.15)] hover:-translate-y-0.5 no-underline"
                aria-label="Connect with Eric on LinkedIn"
              >
                <Linkedin size={22} className="text-primary shrink-0" />
                <span className="font-body text-sm md:text-base text-foreground group-hover:text-foreground transition-colors">
                  Connect on LinkedIn
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-background border-t border-border py-8">
        <div className="content-max flex flex-col items-center gap-4 md:flex-row md:justify-between">
          <p className="font-body text-xs text-muted-foreground">
            © {new Date().getFullYear()} Taylor Growth Consulting, LLC
          </p>
          <div className="flex items-center gap-4 font-body text-xs text-muted-foreground">
            <a
              href="https://linkedin.com/in/ericgriffithtaylor"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={14} />
            </a>
            <span>Irvine, CA</span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ContactSection;
